import { emitter } from 'shared/helpers/mitt';

export default {
  watch: {
    preventDismiss(value) {
      emitter.emit('wgptBoardListCardPreventDismiss', value);
    },
  },
};
